import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import type { FiltersAndSorting } from '../requests-overview-content/requests-overview-content.component';
import { TranslationDirective } from '../../../shared-module/directives/translation.directive';
import { leadSortType } from '../../../../models/leads/leads.model';
import type { MobileFilterSection } from '../requests-overview-mobile-filter-overlay/requests-overview-mobile-filter-overlay.component';

@Component({
  selector: 'fi-requests-overview-top-bar',
  templateUrl: './requests-overview-top-bar.component.html',
  styleUrls: ['./requests-overview-top-bar.component.scss'],
  standalone: false,
})
export class RequestsOverviewTopBarComponent implements OnInit, OnDestroy {
  @Input() filters: FiltersAndSorting;
  @Input() isMobile: boolean;
  @Input() isFinstralUser: boolean;
  @Input() compactView$: Observable<boolean>;
  @Input() showFiltersOnMobile = false;

  @Output() showFiltersOnMobileChange = new EventEmitter<boolean>();
  @Output() filtersChanged = new EventEmitter<void>();
  @Output() queryChanged = new EventEmitter<string>();
  @Output() categoryTypeChanged = new EventEmitter<string>();
  @Output() rangeSelected = new EventEmitter<Date[]>();
  @Output() compactViewToggle = new EventEmitter<boolean>();
  @Output() sortChanged = new EventEmitter<{ sortType: leadSortType; sortDirection: 'ASC' | 'DESC' }>();

  categoryTypes: { [key: string]: string }[];
  categoryPlaceHolder: string;
  selectedCategoryKey: string;
  mobileFilterInitialSection: MobileFilterSection | null = null;

  private translationSubscription: Subscription;

  ngOnInit(): void {
    this.selectedCategoryKey = this.getSelectedCategoryKey(this.filters?.categoryKey);
    this.translationSubscription = TranslationDirective.getTranslations().subscribe(translations => {
      this.categoryTypes = [
        { categoryKey: '', categoryName: translations['REQUEST_OVERVIEW_FILTER_ALL_REQUESTS'] },
        { categoryKey: 'Number', categoryName: translations['SEARCH_CATEGORY_LEAD_ID'] },
        { categoryKey: 'Documents', categoryName: translations['SEARCH_CATEGORY_DOCUMENT'] },
        { categoryKey: 'Contact', categoryName: translations['SEARCH_CATEGORY_CONTACT_DATA'] },
        { categoryKey: 'History', categoryName: translations['SEARCH_CATEGORY_NOTES'] },
        { categoryKey: 'Keywords', categoryName: translations['SEARCH_CATEGORY_KEYWORDS'] },
      ];
      this.categoryPlaceHolder = translations['REQUEST_OVERVIEW_FILTER_ALL_REQUESTS'];
    });
  }

  ngOnDestroy(): void {
    this.translationSubscription?.unsubscribe();
  }

  setShowFiltersOnMobile(show: boolean): void {
    this.showFiltersOnMobile = show;
    this.showFiltersOnMobileChange.emit(show);
  }

  openMobileFilters(section: MobileFilterSection | null = null): void {
    this.mobileFilterInitialSection = section;
    this.setShowFiltersOnMobile(true);
  }

  setCategoriesValue(value: string): void {
    this.selectedCategoryKey = value;
    this.categoryTypeChanged.emit(this.selectedCategoryKey);
  }

  onFilterChanged(): void {
    this.filtersChanged.emit();
    this.setShowFiltersOnMobile(false);
  }

  private getSelectedCategoryKey(categoryKey: string | undefined): string {
    return categoryKey && categoryKey !== 'Filters' ? categoryKey : '';
  }
}
